import { PCBAdditionalProperties } from '@src/quince-site-common/src/domains/ProductComparisonBrand'
import {
  FURNITURE_COVERS_PC_ADDITONAL_ATTRIBUTE_NAME,
  MF_PC_ADDITONAL_ATTRIBUTE_NAME,
  PPS_PC_ADDITONAL_ATTRIBUTE_NAME,
  SERVING_PC_ADDITONAL_ATTRIBUTE_NAME,
  WGD_PC_ADDITONAL_ATTRIBUTE_NAME,
} from '@src/quince-site-common/src/utils/constants'
import { formatPrice } from '@src/quince-site-common/src/utils/formatPrice'

import { CrossIconContainer, GrayCircleContainer } from './ProductPriceComparision'

interface AdditionalPropertyComponentProps {
  additionalProperties: PCBAdditionalProperties[] | undefined
  apName: string
  displayRawValue?: boolean
}

const AdditionalPropertyComponent = ({
  additionalProperties,
  apName,
  displayRawValue,
}: AdditionalPropertyComponentProps) => {
  const additionalProperty = additionalProperties?.find(ap => ap.name === apName)
  const value = additionalProperty?.value
  const showValue = [
    WGD_PC_ADDITONAL_ATTRIBUTE_NAME,
    MF_PC_ADDITONAL_ATTRIBUTE_NAME,
    SERVING_PC_ADDITONAL_ATTRIBUTE_NAME,
    PPS_PC_ADDITONAL_ATTRIBUTE_NAME,
    FURNITURE_COVERS_PC_ADDITONAL_ATTRIBUTE_NAME,
  ].includes(apName)

  if (showValue) {
    if (displayRawValue) {
      return value
    }
    return typeof value === 'number' || typeof value === 'string' ? formatPrice(value) : null
  }

  if (!value) {
    return <CrossIconContainer />
  }

  return <GrayCircleContainer />
}
export default AdditionalPropertyComponent
